<div [formGroup]="cardForm">
  <div class="container cards-container">
    <div class="row middle-textrow">
      <div class="col-md-12 middle-text">
        <span role="heading" aria-level="3" id="page-middleText">
          {{contentData.middleText}}
        </span>
      </div>
    </div>
    <div class="quote-cards-container">
      <div class="row">
        <div class="col-md-12 content-container">
          <div class="col-md-4 cards-holder" *ngFor="let card of processedCard; let i = index;">

            <div id="card{{i}}" class="card-background-copy wh-auto"
              [ngClass]="{'new-card-bg':cardFlag && cardIndex==i,  'new-card-fade':(cardFlag || refreshFlag)&& cardIndex!=i}">

              <img [id]="'closeImg-'+getReferenceAlphabet(i)" alt="resultCard{{i}}" tabindex="0" name="cancel"
                role="button" src="assets/images/close-icon-small.png" srcset="assets/images/close-icon-small@2x.png 2x,
                                    assets/images/close-icon-small@3x.png 3x"
                class="close-icon-small close-icon-2 reflect" (click)="deleteCal(i, card)"
                [ngClass]="{'close-icon-2':cardFlag && cardIndex==i}">

              <div class="Rectangle float-left clear-all" [ngClass]="{'rectangle-padding':cardFlag && cardIndex==i}">
                <header class="a-header" [id]="'header-'+getReferenceAlphabet(i)">{{getReferenceAlphabet(i)}}</header>
                <span class="visually-hidden">Quote {{getReferenceAlphabet(i)}}</span>
              </div>



              <div class="card-flex-container">
                <div class="card-container">
                  <div *ngIf="card.selected" class="row sub-head-card">
                    <p *ngIf="card.selected && !cardFlag && !card.refresh" class="card-text-style">
                      {{contentData.cardText}}</p>
                    <p *ngIf="card.refresh" class="card-text-style">{{contentData.cardRefreshText}}</p>
                    <app-tool-tip-notification *ngIf="card.refresh" [childId]="'cardRefreshInfo'"
                      [tooltipName]="'cardRefresh_tooltip'" class="col-sm-1 toolTip padding-for-toolTip"
                      [tooltipData]="contentData.infoIconData"></app-tool-tip-notification>
                  </div>
                  <div class="row">
                    <div class="header-container">
                      <div class="row clear-all">
                        <div class="col-md-12 text-number-style">

                          <span class="text-style-1"
                            [id]="'currencyType-'+getReferenceAlphabet(i)">{{contentData.currencyType}}</span>
                          <!-- <span *ngIf="selectedProduct.productCode === 'C'" class="number-style" [id]="'currency-'+getReferenceAlphabet(i)">{{getInteger(card, selectedProduct.productCode) | currency:'':'':'1.2-2'}}</span> -->

                          <span class="number-style"
                            [id]="'currency-'+getReferenceAlphabet(i)">{{getIntegerAndFraction(card,
                            selectedProduct.productCode, 'I')}}</span>
                          <!-- <span *ngIf="selectedProduct.productCode === 'H' && (card.benefitBasisModel[0].annualIncome !== null && (card.benefitBasisModel[0].annualIncome.toString() === '0' || card.benefitBasisModel[0].annualIncome > 0))" class="number-style" [id]="'currency-'+getReferenceAlphabet(i)">{{getInteger((card.quickQuoteModel && card.quickQuoteModel.annuitantMaturity) ? (card.quickQuoteModel.annuitantMaturity
                                                | currency:'':'':'1.2-2'):0)}}</span> -->

                          <span class="text-style-2"
                            [id]="'currencyPoint-'+getReferenceAlphabet(i)">{{contentData.currencyPoint}}</span>
                          <span class="text-style-3"
                            [id]="'currencyFraction-'+getReferenceAlphabet(i)">{{getIntegerAndFraction(card,
                            selectedProduct.productCode, 'D')}}</span>


                          <!-- <span *ngIf="selectedProduct.productCode === 'H'" class="a-month" [id]="'currencyFrequency-'+getReferenceAlphabet(i)">{{(card.benefitBasisModel[0].annualIncome !== null && (card.benefitBasisModel[0].annualIncome.toString() === 
                                                '0' || card.benefitBasisModel[0].annualIncome > 0))? contentData.currencyDurationMaturity : (card.quoteBasisModel.paymentFrequency
                                                === 'M'? contentData.currencyDurationMonthly : contentData.currencyDurationYearly)}}</span>-->
                        </div>
                        <div class="col-md-12 frequency-type">
                          <span class="a-month"
                            [id]="'currencyFrequency-'+getReferenceAlphabet(i)">{{getIntegerAndFraction(card,
                            selectedProduct.productCode, 'F')}}</span>
                          <span class="before-tax"
                            [id]="'beforeTax-'+getReferenceAlphabet(i)">{{contentData.beforeTax}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row data-container">
                    <div>
                      <dl>
                        <dt class="col-md-8 Pension-Attributes wd-52">
                          <span *ngIf="selectedProduct.productCode === 'C'"
                            [id]="'annuityLabel-'+getReferenceAlphabet(i)">
                            {{contentData.annuityPensionPotInfo}}</span>
                          <span *ngIf="selectedProduct.productCode === 'H' || selectedProduct.productCode === 'G'"
                            [id]="'annuityLabel-'+getReferenceAlphabet(i)">
                            {{contentData.pensionPotInfo}}</span>
                        </dt>
                        <dd class="col-md-4 Pension-Values">
                          <!--  amount-style removed as part RA-8667 -->
                          <span
                            [id]="'annuityValue-'+getReferenceAlphabet(i)">{{contentData.currencyType}}{{card.benefitBasisModel[0].netPensionFund
                            | currency:'':'':'1.2-2'}}</span>
                        </dd>
                        <dt class="col-md-6 Pension-Attributes">
                          <span [id]="'dateLabel-'+getReferenceAlphabet(i)">{{contentData.startDateInfo}}</span>
                        </dt>
                        <dd class="col-md-6 Pension-Values">
                          <span
                            [id]="'dateValue-'+getReferenceAlphabet(i)">{{card.quoteBasisModel.commencementDate}}</span>
                        </dd>
                        <dt class="col-md-6 Pension-Attributes"
                          *ngIf="selectedProduct.productCode === 'H' || selectedProduct.productCode === 'G'">
                          <span [id]="'incomeLabel-'+getReferenceAlphabet(i)">{{contentData.termInfo}}</span>
                        </dt>
                        <dd class="col-md-6 Pension-Values"
                          *ngIf="selectedProduct.productCode === 'H' || selectedProduct.productCode === 'G'">
                          <span [id]="'termValue-'+getReferenceAlphabet(i)">{{card.quoteBasisModel.policyTerm > 1 ?
                            (card.quoteBasisModel.policyTerm +' '+ contentData.years) :
                            (card.quoteBasisModel.policyTerm
                            +' '+ contentData.year)}}</span>

                          <span *ngIf="card.quoteBasisModel.policyTermMonths>0">{{contentData.comma}}</span>
                          <span *ngIf="card.quoteBasisModel.policyTermMonths>0"
                            [id]="'termValueMonth-'+getReferenceAlphabet(i)">
                            {{card.quoteBasisModel.policyTermMonths > 1 ? (card.quoteBasisModel.policyTermMonths +'
                            '+
                            contentData.months) : (card.quoteBasisModel.policyTermMonths
                            +' '+ contentData.month)}}</span>
                        </dd>
                        <dt class="col-md-6 Pension-Attributes"
                          *ngIf="(selectedProduct.productCode === 'C') || (selectedProduct.productCode === 'G') || (selectedProduct.productCode === 'H' && card.quickQuoteModel.annuitantPension)">
                          <span *ngIf="selectedProduct.productCode !== 'G'"
                            [id]="'incomeLabel-'+getReferenceAlphabet(i)">{{contentData.incomeInfo}}</span>
                          <span *ngIf="selectedProduct.productCode === 'G'"
                            [id]="'paymentFrequencyLabel-'+getReferenceAlphabet(i)">{{contentData.paymentFrequency}}</span>
                        </dt>
                        <dd class="col-md-6 Pension-Values"
                          *ngIf="(selectedProduct.productCode === 'C') || (selectedProduct.productCode === 'G') || (selectedProduct.productCode === 'H' && card.quickQuoteModel.annuitantPension)">
                          <span
                            [id]="'incomeValue-'+getReferenceAlphabet(i)">{{formatIncome(card.quoteBasisModel)}}</span>
                        </dd>
                        <dt class="col-md-6 Pension-Attributes">
                          <span
                            [id]="'increaseIncomeLabel-'+getReferenceAlphabet(i)">{{contentData.incomeIncreaseInfo}}</span>
                        </dt>
                        <dd class="col-md-6 Pension-Values">
                          <span
                            [id]="'increaseIncomeValue-'+getReferenceAlphabet(i)">{{formatIncomeIncrease(card.benefitBasisModel[0])}}</span>
                        </dd>
                        <dt class="col-md-6 Pension-Attributes"
                          *ngIf="card.benefitBasisModel[0].taxFreeCashAmount > 0 || card.benefitBasisModel[0].extTaxFreeCashAmount > 0">
                          <span [id]="'taxFreeLabel-'+getReferenceAlphabet(i)">{{contentData.taxFreeLumpSumInfo
                            }}</span>
                        </dt>
                        <dd class="col-md-6 Pension-Values"
                          *ngIf="card.benefitBasisModel[0].taxFreeCashAmount > 0 || card.benefitBasisModel[0].extTaxFreeCashAmount > 0">
                          <span
                            [id]="'taxFreeValue-'+getReferenceAlphabet(i)">{{contentData.currencyType}}{{getInteger(card.benefitBasisModel[0].taxFreeCashAmount
                            + card.benefitBasisModel[0].extTaxFreeCashAmount) |
                            currency:'':'':'1.0-0'}}{{getFraction(card.benefitBasisModel[0].taxFreeCashAmount +
                            card.benefitBasisModel[0].extTaxFreeCashAmount)}}</span>
                        </dd>
                        <dt class="col-md-6 Pension-Attributes" *ngIf="selectedProduct.productCode === 'H'">
                          <span [id]="'taxFreeLabel-'+getReferenceAlphabet(i)">{{getIntegerAndFraction(card,
                            selectedProduct.productCode, 'K')}}</span>
                        </dt>
                        <dd class="col-md-6 Pension-Values" *ngIf="selectedProduct.productCode === 'H'">
                          <span [id]="'selectedIncomeValue-'+getReferenceAlphabet(i)">{{getIntegerAndFraction(card,
                            selectedProduct.productCode, 'V')}}</span>
                        </dd>
                        <dt class="col-md-6 Pension-Attributes"
                          *ngIf="selectedProduct.productCode === 'C' && card.benefitBasisModel[0].secondLifePensionPercentage">
                          <span
                            [id]="'dependantLabel-'+getReferenceAlphabet(i)">{{contentData.incomeToDependantInfo}}</span>
                        </dt>
                        <dd class="col-md-6 Pension-Values"
                          *ngIf="selectedProduct.productCode === 'C' && card.benefitBasisModel[0].secondLifePensionPercentage">
                          <span
                            [id]="'dependantValue-'+getReferenceAlphabet(i)">{{card.benefitBasisModel[0].vpIndicator==='Ann'?
                            'Not provided': (card.benefitBasisModel[0].secondLifePensionPercentage
                            ? card.benefitBasisModel[0].secondLifePensionPercentage : '0')+
                            contentData.percentage}}</span>
                        </dd>
                        <dt class="col-md-6 Pension-Attributes"
                          *ngIf="selectedProduct.productCode === 'C' && card.benefitBasisModel[0].guaranteedTerm">
                          <span
                            [id]="'guaranteedLabel-'+getReferenceAlphabet(i)">{{contentData.guaranteedPaymentInfo}}</span>
                        </dt>
                        <dd class="col-md-6 Pension-Values"
                          *ngIf="selectedProduct.productCode === 'C' && card.benefitBasisModel[0].guaranteedTerm">
                          <span
                            [id]="'guaranteedValue-'+getReferenceAlphabet(i)">{{(card.benefitBasisModel[0].guaranteedTerm
                            &&
                            card.benefitBasisModel[0].guaranteedTerm > 1 ? (card.benefitBasisModel[0].guaranteedTerm
                            +' '+ contentData.years) : (card.benefitBasisModel[0].guaranteedTerm &&
                            card.benefitBasisModel[0].guaranteedTerm
                            === 1 ? card.benefitBasisModel[0].guaranteedTerm +' '+ contentData.year:null))}}
                          </span>
                        </dd>
                        <dt class="col-md-6 Pension-Attributes"
                          *ngIf="selectedProduct.productCode === 'H' && (card.benefitBasisModel[0].guaranteedTermIndicator || card.benefitBasisModel[0].guaranteedTerm)">
                          <span
                            [id]="'guaranteedLabel-'+getReferenceAlphabet(i)">{{contentData.guaranteedPaymentInfo}}</span>
                        </dt>
                        <dd class="col-md-6 Pension-Values"
                          *ngIf="selectedProduct.productCode === 'H' && (card.benefitBasisModel[0].guaranteedTermIndicator || card.benefitBasisModel[0].guaranteedTerm)">
                          <span [id]="'guaranteedValue-'+getReferenceAlphabet(i)">{{
                            (card.benefitBasisModel[0].guaranteedTermIndicator === 'O' ?
                            card.benefitBasisModel[0].guaranteedTerm :
                            getGuaranteedTermIndicator(card.benefitBasisModel[0])) }}
                            {{ (card.benefitBasisModel[0].guaranteedTermIndicator === 'O' ?
                            (card.benefitBasisModel[0].guaranteedTerm > 1 ? contentData.years
                            : (card.benefitBasisModel[0].guaranteedTerm === 1 ? contentData.year:null)) : '') }}
                          </span>
                        </dd>
                        <dt class="col-md-6 Pension-Attributes"
                          *ngIf="selectedProduct.productCode === 'C' && card.benefitBasisModel[0].vpIndicator ==='Ann' && card.benefitBasisModel[0].vpPercentage!==null ?true:false">
                          <span [id]="'vpLabel-'+getReferenceAlphabet(i)">{{contentData.valueprotectionInfo}}</span>
                        </dt>
                        <dd class="col-md-6 Pension-Values"
                          *ngIf="selectedProduct.productCode === 'C' && card.benefitBasisModel[0].vpIndicator ==='Ann' && card.benefitBasisModel[0].vpPercentage!==null ?true:false">
                          <span
                            [id]="'vpValue-'+getReferenceAlphabet(i)">{{(card.benefitBasisModel[0].vpIndicator==='Inc'
                            ||
                            card.benefitBasisModel[0].vpIndicator==='Ne') ? 'Not
                            provided':card.benefitBasisModel[0].vpPercentage +contentData.percentage}}

                          </span>
                        </dd>
                        <!--<dt class="col-md-6 Pension-Attributes">
                                                                                          
                                                                                        </dt>
                                                                                        <dd class="col-md-6 Pension-Values">
                                                                    
                                                                                        </dd> -->
                      </dl>
                    </div>

                  </div>

                </div>
                <div class="row button-container">
                  <div class="padding-top-bottom"
                    *ngIf="!card.refresh && ((cardFlag == false && doneFlag == false) || cardIndex != i)">
                    <button [id]="'btnEdit-'+getReferenceAlphabet(i)" tabindex="0"
                      class="bg button-border btn-hover reflect-choose" (click)="editCal(i,card)"
                      [disabled]="cardFlag && cardIndex!=i" [ngClass]="{'link-button-fade':cardFlag && cardIndex!=i}">
                      {{contentData.editCalcButn}}
                    </button>
                  </div>
                  <div class="padding-bottom"
                    *ngIf="!card.refresh && ((cardFlag == false && doneFlag == false) || cardIndex != i)">
                    <button class="btn btn-secondary btnFix" (click)="choose(i,card,cardFlag)" type="button"
                      (keyup.enter)="choose(i,card,cardFlag)" (keyup.Space)="choose(i,card,cardFlag)"
                      [ngClass]="{'link-button-fade':cardFlag && cardIndex!=i}"
                      [id]="'chooseImg-'+getReferenceAlphabet(i)" alt="choose button">
                      {{contentData.chooseBtn}}
                    </button>
                    <!-- <app-button (click)="choose(i,card)" [buttonType]="'secondarychoosebutton'" [isDisabled]="cardFlag" [parent]="cardForm" [controllerData]="userInputDetail['buttonChooseConfig']"></app-button> -->
                  </div>
                  <div class="col-md-12 done-edit-btn" *ngIf="(cardFlag == true || doneFlag == true) && cardIndex == i">
                    <button *ngIf="!doneFlag" class="btn2 button-border reflect-done"
                      [id]="'btnDoneEdit-'+getReferenceAlphabet(i)"
                      (click)="done(i,card)">{{contentData.doneEditingBtn}}</button>
                    <button *ngIf="doneFlag" class="btn btn-secondary btn-loading no-border" type="button"
                      disabled="disabled">
                      <span class="btn-text">Secondary button</span>
                      <div class="spinner">
                        <div class="spinner-ring" aria-hidden="true"></div>
                        <span class="access">Loading...</span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty Card Starts from here-->

          <div class="col-md-4 cards-holder " *ngIf="processedCard.length <= 5  && cardFlag==false">

            <div class="card-background-copy">

              <div class="empty-card-title">

                <div class="row">
                  <div class="col-md-12">
                    <p id="blankCard"> {{contentData.quoteCardInfo}}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- Empty Card Ends Here -->
        </div>
      </div>

    </div>
  </div>
  <app-modal *ngIf="isLocked" [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()"
    (primaryBtnClick)="closeLockedModal()" [saveDataFlag]="false">
  </app-modal>